/** Participant email login OTP length (must match API and email template). */
export const PARTICIPANT_OTP_LENGTH = 4;

export const PARTICIPANT_OTP_EXPIRY_MINUTES = 5;
